import { configureStore } from '@reduxjs/toolkit';
import sidebarSlice from './sidebar.slice';
import { productsReducer } from './products';
import { singleProductReducer } from './single-product';
import { storeFrontAuthReducer, storeFrontAuthMiddlewares } from './store-front-auth';

const store = configureStore({
  reducer: {
    sidebar: sidebarSlice.reducer,
    products: productsReducer,
    singleProduct: singleProductReducer,
    storeFrontAuth: storeFrontAuthReducer
  },
  middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(storeFrontAuthMiddlewares.handleHttpResponseMiddleware)
});

export type RootState = ReturnType<typeof store.getState>;
export default store;
